<template>
    <div>
        <transition name="modal" v-if="carregando">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
                        <label>Aguarde. Carregando.</label>
                    </div>
                </div>
            </div>
        </transition>
        <div v-else>
            <div v-if="erro">
                <div v-if="flag == 0">
                    <SemPermissao></SemPermissao>
                </div>
                <div v-else>
                    <ErroAutorizacao></ErroAutorizacao>
                </div>
            </div>
            <template v-if="!erro">
                <OrgaoForm :orgao="orgao" />
            </template>
        </div>
    </div>
</template>

<script>
    import OrgaoApi from "../../services/OrgaoApi"
    import SemPermissao from "../SemPermissao.vue"
    
    //import ErroResultados from "../../components/ErroResultados";
    import OrgaoForm from "../../components/orgaos/OrgaoForm.vue"
    import metaDados from "../../helpers/metaDados";

    export default {
        name: "OrgaoEdit",
        metaInfo() {
            if (!this.orgao) {
                return {};
            }

            let title = this.orgao.nome;
            const description = this.orgao.nome;

            return {
                titleTemplate: "%s - Casa Civil do Estado de Goiás",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        property: "description",
                        content: description,
                    },
                    {
                        vmid: "og:description",
                        property: "og:description",
                        content: description,
                    },
                    {
                        vmid: "og:title",
                        property: "og:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    {
                        vmid: "twitter:description",
                        name: "twitter:description",
                        property: "twitter:description",
                        content: description,
                    },
                    {
                        vmid: "twitter:title",
                        name: "twitter:title",
                        property: "twitter:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    ...metaDados(this.$route),
                ],
            };
        },
        data() {
            return {
                carregando: true,
                erro: false,
                flag: 0,
                orgao: null,
            };
        },
        components: {
            //ErroResultados,
            SemPermissao,
            OrgaoForm,
        },
        created() {
            this.OrgaoApi = new OrgaoApi();
            this.carregarOrgao();
        },
        watch: {
            $route: function (to, from) {
                if (to.params.id != from.params.id) {
                    this.carregarOrgao();
                }
            },
        },
        methods: {
            carregarOrgao: async function () {
                try {
                    this.carregando = true;
                    this.erro = false;

                    if (this.OrgaoApi.cancelTokens.getOrgao) {
                        this.OrgaoApi.cancelTokens.getOrgao.cancel();
                    }

                    const dadosOrgao = await this.OrgaoApi.getOrgao(
                        this.$route.params.id
                    );
                    this.orgao = dadosOrgao

                    this.carregando = false;
                } catch (err) {
                    if (this.OrgaoApi.isCancel(err)) {
                        return;
                    }
                    console.log(err);

                    this.erro = true;
                    this.carregando = false;
                    this.orgao = null;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
</style>